import awsRegions from '@/constants/awsRegions'
import { StreamEvent } from '@/types/streams/event'

export const getAWSRegionCode = (
  event: Omit<StreamEvent, 'streamingConfig'>
): keyof typeof awsRegions | null => {
  return (event?.defaultRegion || event.tournament?.defaultRegion) as keyof typeof awsRegions | null
}

export const getAWSRegionName = (event: Omit<StreamEvent, 'streamingConfig'>): string => {
  const regionCode = getAWSRegionCode(event) || 'Unknown Region'
  const regionName = awsRegions?.[regionCode as keyof typeof awsRegions]
  return regionName ? `${regionName} - ${regionCode}` : regionCode
}
